module.exports = __webpack_public_path__ + "static/media/mes-6.3a6725a5.jpg";